// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__omLk9","card":"Cart_card__QC+AR","quantity":"Cart_quantity__WCUng","total":"Cart_total__FU+JH","checkout-button":"Cart_checkout-button__Cl642"};